import { render, staticRenderFns } from "./school-information.vue?vue&type=template&id=26a59f73&scoped=true&"
import script from "./school-information.vue?vue&type=script&lang=js&"
export * from "./school-information.vue?vue&type=script&lang=js&"
import style0 from "./school-information.vue?vue&type=style&index=0&id=26a59f73&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a59f73",
  null
  
)

export default component.exports